import script from "./Internal-Milestone-Task.vue?vue&type=script&setup=true&lang=js"
export * from "./Internal-Milestone-Task.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__